import axios from "axios";
import { checkStatus, parseJSON } from "./responseHandler";
import { BASE_API_URL } from "../utils/constant";
import { SessionHelper } from "../utils/session"
// Make an api call

export default async (url, method = "post", body) => {
	return axios(`${BASE_API_URL}${url}`, {
		method,
		data: body ? body : null,
		headers: SessionHelper.getHeader()
	})
		.then(checkStatus)
		.then(parseJSON)
		.catch(error => {
			throw error;
		});
};